"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var TextProductItem = function TextProductItem(_ref) {
  var name = _ref.name,
      price = _ref.price,
      _ref$currencySign = _ref.currencySign,
      currencySign = _ref$currencySign === void 0 ? '' : _ref$currencySign,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$hidePrice = _ref.hidePrice,
      hidePrice = _ref$hidePrice === void 0 ? false : _ref$hidePrice,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["name", "price", "currencySign", "loading", "hidePrice"]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    component: "span"
  }, boxProps), loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 150
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, name, "\xA0", !hidePrice && /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(currencySign, "0,0.00")
  }, price)));
};

var _default = TextProductItem;
exports.default = _default;